
<div class="generalPage" aria-label="helppcsfaq" role="main">
  <div class="pr-22 content-container pb-0  print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader content-blue font-32" role="heading" tabindex="0">{{FAQ_Header}}</h1>
    <br />
    <br />
    <h2 class="top-heading content-blue font-24 mt-1rem" tabindex="0">{{FAQ_GeneralHeader}}</h2>
    <p class="answer font-16 content-blue width-100 mt-0"  [innerHTML]="FAQ_GeneralDescription" tabindex="0"></p>
    <h2 class="top-heading content-blue font-24" tabindex="0">{{FAQ_UserInputHeader}}</h2>
    <p class="answer font-16 content-blue width-100 mt-0" [innerHTML]="FAQ_UserInputDescription" tabindex="0"></p>
      <h2 id="limitations" class="top-heading content-blue font-24"  tabindex="1">{{FAQ_SystemLimitationHeader}}</h2>
      <p class="answer font-16 content-blue width-100 pb-1rem mt-0" [innerHTML]="FAQ_SystemLimitationDescription" tabindex="0"></p>
    </div>
</div>

